import { render } from "./GenericContentComponent.vue?vue&type=template&id=7edb6772&scoped=true"
import script from "./GenericContentComponent.vue?vue&type=script&lang=js"
export * from "./GenericContentComponent.vue?vue&type=script&lang=js"

import "./GenericContentComponent.vue?vue&type=style&index=0&id=7edb6772&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edb6772"]])

export default __exports__